import { createSlice } from '@reduxjs/toolkit';
import { filtraDati, filtraDatiPerZona } from 'views/dashboard/funzioni';

import _ from 'lodash';

const initialState = {
  caricamentoInCorso: true,
  fatturati: [],
  raggruppamento: 'Product',
  fatturatiRaw: [],
  errore: false,
  currentCliente: false,
  fatturatiPerCliente: false,
  anno: new Date().getFullYear(),
  datiPerAnno: [],
  valuta: '€',
  zona: 'all',
  anni: [],
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaFatturati(state, action) {
      state.fatturati = action.payload;
    },
    aggiornaFatturatiRaw(state, action) {
      state.fatturatiRaw = action.payload;
    },
    aggiornaRaggruppamento(state, action) {
      const datiFiltrati = filtraDati(state.fatturatiRaw, action.payload, state.anno);
      state.fatturati = datiFiltrati;
      state.raggruppamento = action.payload;
      state.zona = 'all';
    },
    errore(state, action) {
      state.errore = action.payload;
    },
    aggiornaCurrentCliente(state, action) {
      state.currentCliente = action.payload;
    },
    aggiornaFatturatiPerCliente(state, action) {
      state.fatturatiPerCliente = action.payload;
    },
    aggiornaAnno(state, action) {
      const datiFiltrati = filtraDati(state.fatturatiRaw, state.raggruppamento, action.payload);
      state.fatturati = datiFiltrati;
      state.anno = action.payload;
      state.zona = 'all';
    },
    aggiornaValuta(state, action) {
      state.valuta = action.payload;
    },
    aggiornaZona(state, action) {
      state.zona = action.payload;
      const datiFiltrati = filtraDatiPerZona(state, action.payload);
      state.fatturati = datiFiltrati;
    },
    aggiornaAnni(state, action) {
      state.anni = action.payload;
    },
  },
});

export const {
  caricamento,
  aggiornaFatturati,
  aggiornaFatturatiRaw,
  aggiornaRaggruppamento,
  errore,
  aggiornaCurrentCliente,
  aggiornaFatturatiPerCliente,
  aggiornaAnno,
  aggiornaValuta,
  aggiornaZona,
  aggiornaAnni,
} = dashboardSlice.actions;
const dashboardReducer = dashboardSlice.reducer;

export default dashboardReducer;
